module.exports = __webpack_public_path__ + "img/table-bg-mobile.54de8023.webp";